import { checkLength, maybe, wrapIn, wrapInArray } from 'site-modules/shared/utils/incentives/gql-incentives-filter';
import { CONTENT_TYPES } from 'site-modules/shared/constants/incentives';

class FilterBuilder {
  constructor(incentivesFilter) {
    this.incentivesFilter = incentivesFilter;
    this.filters = {};
  }

  withZip() {
    this.filters.zip = this.incentivesFilter.zip;
    return this;
  }

  withEngineTypes() {
    this.filters.engineTypes = this.incentivesFilter.engineTypes;
    return this;
  }

  withActiveDate() {
    this.filters.activeDate = this.incentivesFilter.activeDate;
    return this;
  }

  withMakeSlugs() {
    this.filters.makeSlugs = maybe(this.incentivesFilter.makeSlug).map(wrapIn).unpack();
    return this;
  }

  withModelSlugs() {
    this.filters.modelSlugs = maybe(this.incentivesFilter.modelSlug).map(wrapIn).unpack();
    return this;
  }

  withStyleIds() {
    this.filters.styleIds = maybe(this.incentivesFilter.styleId).map(wrapInArray).unpack();
    return this;
  }

  withTransactionTypes() {
    this.filters.transactionTypes = maybe(this.incentivesFilter.transactionType).map(wrapIn).unpack();
    return this;
  }

  withInventoryCodes() {
    this.filters.inventoryCodes = maybe(this.incentivesFilter.inventoryCode)
      .map(inventoryCode => inventoryCode.split(','))
      .unpack();
    return this;
  }

  withProgramTypesFilter() {
    this.filters.programTypesFilter = maybe(this.incentivesFilter.programTypes).map(checkLength).map(wrapIn).unpack();
    return this;
  }

  withYears() {
    this.filters.years = maybe(this.incentivesFilter.years).map(wrapIn).unpack();
    return this;
  }

  withTypes() {
    this.filters.types = {
      in: [
        CONTENT_TYPES.OTHER_OFFERS,
        CONTENT_TYPES.CUSTOMER_CASH,
        CONTENT_TYPES.CUSTOMER_CASH_AND_APR,
        CONTENT_TYPES.TEXT_ONLY,
        CONTENT_TYPES.NON_CASH_TO_CUSTOMER,
      ],
    };
    return this;
  }

  build() {
    return this.filters;
  }
}

export const createInventoryIncentiveListGqlFilter = incentivesFilter => {
  const builder = new FilterBuilder(incentivesFilter);
  return builder.withZip().withTypes().withActiveDate().withTransactionTypes().withEngineTypes().build();
};

export const createIncentiveAggregationsGqlFilter = incentivesFilter => {
  const builder = new FilterBuilder(incentivesFilter);
  return builder
    .withZip()
    .withEngineTypes()
    .withActiveDate()
    .withMakeSlugs()
    .withModelSlugs()
    .withStyleIds()
    .withTransactionTypes()
    .withInventoryCodes()
    .withProgramTypesFilter()
    .withYears()
    .withTypes()
    .build();
};
